module.exports = __webpack_public_path__ + "static/media/asiru1.214e86db.png";